module.exports = __webpack_public_path__ + "static/regione.f513fcec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/regione.jpg
// module id = 1621
// module chunks = 35783957827783